import React, { FC } from 'react';

import { LucidTheme, mqMin, getColor } from '@lucid/theme';

import Box from '../box/box';
import Container from '../container/container';
import Heading from '../heading/heading';
import Link from '../link/link';
import Paper from '../paper/paper';
import { ComponentLink } from '../../types/generics';

export interface SimpleCtaProps {
  /** The cta url & text. */
  cta: ComponentLink;
  /** Sets the top half of the background to transparent */
  overlapColor?: string;
  /** The text displayed in the card, next to the button. */
  heading: string;
}

const SimpleCta: FC<SimpleCtaProps> = ({ cta, overlapColor = 'transparent', heading }) => (
  <Box
    css={(theme: LucidTheme) => ({
      background: `linear-gradient(${getColor({ color: overlapColor, theme })} 50%, transparent 50%)`
    })}
    py="10"
  >
    <Container displayFlex>
      <Paper
        css={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flexWrap: 'wrap'
        }}
      >
        <Heading
          as="h2"
          css={{
            flex: '0 1 100%',
            [mqMin.tabletSmall]: {
              flex: '1 1',
              marginRight: '56px'
            },
            [mqMin.tablet]: {
              flex: '1 1',
              marginRight: '84px'
            }
          }}
          m="0"
          variant="headline2XL"
        >
          {heading}
        </Heading>
        <Box
          css={{
            alignSelf: 'center',
            justifyContent: 'center'
          }}
          display="flex"
          flex={{ default: '0 1 100%', tabletSmall: '0 1' }}
          justifyContent="flex-end"
          mt={{ default: '2rem', tabletSmall: '0' }}
        >
          <Link
            displayAsButton
            primary
            css={{
              flex: '1 1 100%',
              [mqMin.mobile]: {
                flex: '0 1 auto',
                minWidth: '222px'
              }
            }}
            to={cta.linkUrl}
          >
            {cta.linkText}
          </Link>
        </Box>
      </Paper>
    </Container>
  </Box>
);

export { SimpleCta };
export default SimpleCta;
